// services/fontteService/updates.ts - services/fontteService.ts split (sub-module updates)


import type {FontteResponse} from './types.js';
import { sendWhatsAppMessage } from './base.js';


export async function sendShippingUpdate(
    phoneNumber: string,
    orderData: { orderId: string; customerName: string; shippingNumber: string; courier: string; estimatedDelivery?: string },
    options?: { device?: string; customApiKey?: string }
): Promise<FontteResponse> {
    const message = `
Halo ${orderData.customerName},

Pesanan kakak udah dikirim hari ini! 🎉📦

📋 *Detail Pengiriman*
- Pesanan: ${orderData.orderId}
- Resi: ${orderData.shippingNumber}
- Kurir: ${orderData.courier.toUpperCase()}
${orderData.estimatedDelivery ? `- Estimasi sampai: ${orderData.estimatedDelivery}` : ''}

Link tracking: https://tracking.com/track/${orderData.shippingNumber}

Siap-siap ya, paketnya segera nyampe 🚚💨
`.trim();

    return sendWhatsAppMessage(phoneNumber, message, '62', options?.device, options?.customApiKey);
}



export async function sendDeliveryConfirmation(
    phoneNumber: string,
    orderData: { orderId: string; customerName: string; productName: string },
    options?: { device?: string; customApiKey?: string }
): Promise<FontteResponse> {
    const message = `
Halo ${orderData.customerName},

Paket ${orderData.productName} udah diterima ya? Semoga suka sama produknya! 🎉

Kalo ada yang kurang pas atau butuh bantuan, kabarin aja ya — kita siap bantu 🙌

Makasih udah belanja, Kak! 🫶
`.trim();

    return sendWhatsAppMessage(phoneNumber, message, '62', options?.device, options?.customApiKey);
}



export async function sendCancellationMessage(
    phoneNumber: string,
    orderData: { orderId: string; customerName: string; reason?: string },
    options?: { device?: string; customApiKey?: string }
): Promise<FontteResponse> {
    const message = `
Halo ${orderData.customerName},

Pesanan ${orderData.orderId} udah dibatalkan ya ❌

${orderData.reason ? `Alasan: ${orderData.reason}` : ''}

Kalo ada yang mau ditanyain atau mau order lagi, kabarin aja ya 🙏
`.trim();

    return sendWhatsAppMessage(phoneNumber, message, '62', options?.device, options?.customApiKey);
}
